import { GuestVenue } from "./GuestVenue";

export class GuestSurvey {
	checkKey: string;
	seatKey: number;
	guestGuid: string;
	venueKey: number;
	happy: boolean;
	comment: string;
	phoneNumber: string;
	email: string;
	firstName: string;
	lastName: string;
	created: Date;
	responded: boolean;

	GuestVenue: GuestVenue;

	public constructor(init?: Partial<GuestSurvey>) {
		Object.assign(this, init);
	}
}
